export const emptyData = {
  ip: "",
  as: {
    domain: "",
    type: "",
  },
  isp: "",
  location: {
    country: "",
    region: "",
    timezone: "",
    lat: 0,
    lng: 0,
  },
};
